export const storagePrefix: string = 'ls-v2-4__';
export const ignoreLocalStorageItem = [
  'status2fa',
  'auth-token',
  'active-team',
  'loglevel:webpack-dev-server',
  'language',
];
